import { styled } from "@mui/system";
  import { Box } from "@mui/material";

  export const ChatBotInterfaceStyles = styled(Box)(({ theme, isDisabled }) => ({
    "&.chatContainer": {
      flexGrow: 1,
      maxWidth: '100%',
      maxHeight: '100%',
      height: '100%',
      backgroundColor: theme.palette.grey.light2, // Custom grey background color
      borderRadius: theme.spacing(1), // Equivalent to 8px
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    "& .messagesContainer": {
      flexGrow: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
      width: '100%',
      paddingBottom: theme.spacing(2), // Equivalent to 16px
      backgroundColor: theme.palette.grey.sky, // Custom light blue background color
      display: 'flex',
      flexDirection: 'column',
      paddingRight: theme.spacing(2), // Equivalent to 16px
      paddingLeft: theme.spacing(2), // Equivalent to 16px
      paddingTop: theme.spacing(2), // Equivalent to 16px
      maxHeight: '100%',
      height: '100%',
      alignItems: 'center',
    },
  "& .inputContainer": {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    backgroundColor: theme.palette.grey.sky,
    alignItems: 'center', // Center the input row
  },
  "& .inputRow": {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.grey.light, // Grey background for input
    borderRadius: theme.spacing(3), // Rounded edges
    border: `0.5px solid ${theme.palette.grey.main}`,
    padding: theme.spacing(0.5, 1.5), // Padding inside the input row
    width: '98%', // Reduced width (adjust as needed)
  },
  "& .aiNote": {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.grey.dark,
    textAlign: 'center',
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.7),
    fontStyle: 'italic',
    backgroundColor: theme.palette.grey.light2,
  },
  "& .sendButton": {
    marginLeft: theme.spacing(0.5),
    color: theme.palette.primary.main,
    minWidth: 'auto', // Remove minimum width
    padding: theme.spacing(0.5), // Reduce button padding
  },
    "& .sendIcon": {
      fontSize: theme.typography.pxToRem(40), // Icon size remains in pixels for consistency
      background: isDisabled ? theme.palette.grey.medium : theme.palette.primary.main, // Dynamic color based on disabled state
      borderRadius: '50%',
      padding: theme.spacing(1), // Equivalent to 8px
      color: theme.palette.white.main, // Icon color remains white
    },
    "& .chatBotMessageHeader": {
      display: 'flex',
      alignItems: 'flex-start',
      alignSelf: 'flex-start',
      marginRight: theme.spacing(0.5), // Equivalent to 4px
      marginLeft: theme.spacing(0.5), // Equivalent to 4px
    },
    "& .chatBotMessageHeaderText": {
      alignItems: 'flex-start',
      alignSelf: 'flex-start',
      fontSize: theme.typography.pxToRem(16), // Use rem for font sizing
      marginLeft: theme.spacing(0.5), // Equivalent to 4px
      fontWeight: 600,
    },
    "& .dateHeaderText": {
      alignItems: 'flex-start',
      alignSelf: 'flex-start',
      fontSize: theme.typography.pxToRem(10), // Use rem for font sizing
      marginLeft: theme.spacing(0.875), // Equivalent to 7px
      color: theme.palette.grey.medium, // Custom medium grey color
      fontWeight: 550,
      transform: 'translateY(5.5px)', // Keep precise positioning as is
    },
    "& .userMessageHeader": {
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'flex-end',
    },
    "& .userMessageHeaderText": {
      fontSize: theme.typography.pxToRem(15), // Use rem for font sizing
      alignSelf: 'flex-end',
      fontWeight: 600,
    },
    "& .retryButtonContainer": {
      display: 'flex',
      justifyContent: 'flex-start',
      alignSelf: 'flex-start',
      width: '100%',
      marginTop: theme.spacing(0.5),
      marginLeft: theme.spacing(4), // Align with bot message content
      gap: theme.spacing(0.5), // Add space between buttons
    },
"& .retryButton": {
  color: theme.palette.grey.medium,
  fontSize: '0.75rem',
  padding: theme.spacing(0.25, 0.5),
  minWidth: 'auto',
  textTransform: 'none',
  borderRadius: theme.spacing(1), // Add rounded edges
  '&:hover': {
    backgroundColor: theme.palette.grey.light, // Darker background on hover
    color: theme.palette.grey.dark,
  },
  '& .MuiTypography-root': {
    color: theme.palette.grey.medium,
    fontSize: theme.typography.pxToRem(12),
  },
  '&:hover .MuiTypography-root': {
    color: theme.palette.grey.dark, // Ensure text color changes on hover
  },
},
    "& .textField": {
      '& .MuiInput-underline:before': {
        borderBottom: 'none', // Remove default underline before hover
      },
      '& .MuiInput-underline:hover:before': {
        borderBottom: 'none', // Remove underline on hover
      },
      '& .MuiInput-underline:after': {
        borderBottom: 'none', // Remove default underline after focus
      },
    },
  }));

  export default ChatBotInterfaceStyles;